export default __webpack_public_path__ + "static/media/sample-photobook.b0c6d049.png";